export default class TreeSelectorNode{

    item=null;
    level =1;
    parent = null;
    children = [];
    opened = false;

    //0部分选择 1 选择 -1未选,用于设置显示
    selectState=-1;	
    //0部分选择 1 选择 -1未选,用于收集结果
    editState = -1;

    constructor(item){
        this.item = item;
    }

    getItem(){
        return this.item;
    }

    getLevel(){
        return this.level;
    }

    setLevel(level){
        this.level = level;
    }

    getParent(){
        return this.parent;
    }

    setParent(parent){
        this.parent = parent;
    }

    getChildren(){
        return this.children;
    }

    setChildren(children){
        if(!children)
            this.children = null;
        else
            this.children = children;
    }

    addChild(node){
        this.children.push(node);
    }

    isOpened(){
        return this.opened;
    }

    setOpened(opened){
        this.opened = opened;
    }

    //展示状态，根据外部传入的VALUE来控制
    getSelectState(){
        return this.selectState;
    }

    setSelectState(selectState){
        this.selectState = selectState;
    }
    //编辑状态，编辑后设置，然后传给外部，外部跟新VALUE后，同步到组件内部同时更新展示状态和编辑状态
    getEditState(){
        return this.editState;
    }

    setEditState(editState){
        this.editState = editState;
    }

}